module.exports = __webpack_public_path__ + "static/media/sim.e3e0ac67.png";